"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAnimation = createAnimation;
exports.iconAnimation = iconAnimation;

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _Animation = _interopRequireDefault(require("./02/Animation02"));

var _Animation2 = _interopRequireDefault(require("./03/Animation03"));

var _Animation3 = _interopRequireDefault(require("./04/Animation04"));

var _Animation4 = _interopRequireDefault(require("./05/Animation05"));

var _Animation5 = _interopRequireDefault(require("./06/Animation06"));

var _Animation6 = _interopRequireDefault(require("./08/Animation08"));

var _Animation7 = _interopRequireDefault(require("./10/Animation10"));

var _Animation8 = _interopRequireDefault(require("./12/Animation12"));

var _Animation9 = _interopRequireDefault(require("./13/Animation13"));

var _Animation10 = _interopRequireDefault(require("./14/Animation14"));

var _Animation11 = _interopRequireDefault(require("./17/Animation17"));

var _Animation12 = _interopRequireDefault(require("./18/Animation18"));

var _Animation13 = _interopRequireDefault(require("./19/Animation19"));

var _Animation14 = _interopRequireDefault(require("./20/Animation20"));

var _Animation15 = _interopRequireDefault(require("./21/Animation21"));

var _Animation16 = _interopRequireDefault(require("./23/Animation23"));

var _Animation17 = _interopRequireDefault(require("./24/Animation24"));

var _Animation18 = _interopRequireDefault(require("./25/Animation25"));

var _Animation19 = _interopRequireDefault(require("./28/Animation28"));

var _Animation20 = _interopRequireDefault(require("./29/Animation29"));

var _Animation21 = _interopRequireDefault(require("./31/Animation31"));

var _Animation22 = _interopRequireDefault(require("./33/Animation33"));

var _Animation23 = _interopRequireDefault(require("./39/Animation39"));

var _Animation24 = _interopRequireDefault(require("./40/Animation40"));

var _Animation25 = _interopRequireDefault(require("./41/Animation41"));

var _Animation26 = _interopRequireDefault(require("./42/Animation42"));

var _Animation27 = _interopRequireDefault(require("./43/Animation43"));

var _Animation28 = _interopRequireDefault(require("./44/Animation44"));

var _Animation29 = _interopRequireDefault(require("./45/Animation45"));

var _Animation30 = _interopRequireDefault(require("./46/Animation46"));

var _Animation31 = _interopRequireDefault(require("./47/Animation47"));

var _Animation32 = _interopRequireDefault(require("./48/Animation48"));

var _Animation33 = _interopRequireDefault(require("./50/Animation50"));

var _Animation34 = _interopRequireDefault(require("./51/Animation51"));

var _Animation35 = _interopRequireDefault(require("./52/Animation52"));

var _Animation36 = _interopRequireDefault(require("./53/Animation53"));

var _Animation37 = _interopRequireDefault(require("./55/Animation55"));

var _Animation38 = _interopRequireDefault(require("./56/Animation56"));

var _Animation39 = _interopRequireDefault(require("./58/Animation58"));

var _Animation40 = _interopRequireDefault(require("./59/Animation59"));

var _Animation41 = _interopRequireDefault(require("./60/Animation60"));

var _Animation42 = _interopRequireDefault(require("./61/Animation61"));

var _Animation43 = _interopRequireDefault(require("./62/Animation62"));

var _Animation44 = _interopRequireDefault(require("./63/Animation63"));

var _Animation45 = _interopRequireDefault(require("./64/Animation64"));

var _Animation46 = _interopRequireDefault(require("./65/Animation65"));

var _Animation47 = _interopRequireDefault(require("./66/Animation66"));

var _Animation48 = _interopRequireDefault(require("./67/Animation67"));

var _Animation49 = _interopRequireDefault(require("./68/Animation68"));

var _Animation50 = _interopRequireDefault(require("./69/Animation69"));

var _Animation51 = _interopRequireDefault(require("./70/Animation70"));

var _AnimationTrustPilot = _interopRequireDefault(require("./trustpilot/animation/01/AnimationTrustPilot01"));

var _Outro = _interopRequireDefault(require("./outros/01/Outro01"));

var _Outro2 = _interopRequireDefault(require("./outros/03/Outro03"));

var _Outro3 = _interopRequireDefault(require("./outros/04/Outro04"));

var _Outro4 = _interopRequireDefault(require("./outros/05/Outro05"));

var _Outro5 = _interopRequireDefault(require("./outros/06/Outro06"));

var _Outro6 = _interopRequireDefault(require("./outros/07/Outro07"));

var _Outro7 = _interopRequireDefault(require("./outros/08/Outro08"));

var _Outro8 = _interopRequireDefault(require("./outros/09/Outro09"));

var _Outro9 = _interopRequireDefault(require("./outros/10/Outro10"));

var _Outro10 = _interopRequireDefault(require("./outros/11/Outro11"));

var _Outro11 = _interopRequireDefault(require("./outros/15/Outro15"));

var _Outro12 = _interopRequireDefault(require("./outros/21/Outro21"));

var _Outro13 = _interopRequireDefault(require("./outros/22/Outro22"));

var _Outro14 = _interopRequireDefault(require("./outros/25/Outro25"));

var _Outro15 = _interopRequireDefault(require("./outros/26/Outro26"));

var _Outro16 = _interopRequireDefault(require("./outros/27/Outro27"));

var _OutroTrustPilot = _interopRequireDefault(require("./trustpilot/outro/OutroTrustPilot01"));

var _Photo2 = _interopRequireDefault(require("./photos/01/Photo01"));

var _AnimationUploaded2 = _interopRequireDefault(require("./uploaded/AnimationUploaded"));

var _OutroUploaded2 = _interopRequireDefault(require("./uploaded/OutroUploaded"));

var _IconAnimation = _interopRequireDefault(require("./icons/IconAnimation"));

var _WatermarkImage = _interopRequireDefault(require("./watermark/WatermarkImage"));

var _Template63 = _interopRequireDefault(require("./templates/62/Template62"));

var _Template64 = _interopRequireDefault(require("./templates/67/Template67"));

var _Template65 = _interopRequireDefault(require("./templates/33/Template33"));

var _Template66 = _interopRequireDefault(require("./templates/47/Template47"));

var _Template67 = _interopRequireDefault(require("./templates/24/Template24"));

var _Template68 = _interopRequireDefault(require("./templates/15/Template15"));

var _Template69 = _interopRequireDefault(require("./templates/14/Template14"));

var _Template70 = _interopRequireDefault(require("./templates/12/Template12"));

var _Template71 = _interopRequireDefault(require("./templates/10/Template10"));

var _Template72 = _interopRequireDefault(require("./templates/9/Template9"));

var _Template73 = _interopRequireDefault(require("./templates/1/Template1"));

var _Template74 = _interopRequireDefault(require("./templates/13/Template13"));

var _Template75 = _interopRequireDefault(require("./templates/11/Template11"));

var _Template76 = _interopRequireDefault(require("./templates/18/Template18"));

var _Template77 = _interopRequireDefault(require("./templates/20/Template20"));

var _Template78 = _interopRequireDefault(require("./templates/27/Template27"));

var _Template79 = _interopRequireDefault(require("./templates/29/Template29"));

var _Template80 = _interopRequireDefault(require("./templates/30/Template30"));

var _Template81 = _interopRequireDefault(require("./templates/31/Template31"));

var _Template82 = _interopRequireDefault(require("./templates/37/Template37"));

var _Template83 = _interopRequireDefault(require("./templates/38/Template38"));

var _Template84 = _interopRequireDefault(require("./templates/44/Template44"));

var _Template85 = _interopRequireDefault(require("./templates/45/Template45"));

var _Template86 = _interopRequireDefault(require("./templates/48/Template48"));

var _Template87 = _interopRequireDefault(require("./templates/49/Template49"));

var _Template88 = _interopRequireDefault(require("./templates/55/Template55"));

var _Template89 = _interopRequireDefault(require("./templates/57/Template57"));

var _Template90 = _interopRequireDefault(require("./templates/58/Template58"));

var _Template91 = _interopRequireDefault(require("./templates/59/Template59"));

var _Template92 = _interopRequireDefault(require("./templates/60/Template60"));

var _Template93 = _interopRequireDefault(require("./templates/61/Template61"));

var _Template94 = _interopRequireDefault(require("./templates/63/Template63"));

var _Template95 = _interopRequireDefault(require("./templates/65/Template65"));

var _Template96 = _interopRequireDefault(require("./templates/71/Template71"));

var _Template97 = _interopRequireDefault(require("./templates/79/Template79"));

var _Template98 = _interopRequireDefault(require("./templates/80/Template80"));

var _Template99 = _interopRequireDefault(require("./templates/81/Template81"));

var _Template100 = _interopRequireDefault(require("./templates/83/Template83"));

var _Template101 = _interopRequireDefault(require("./templates/84/Template84"));

var _Template102 = _interopRequireDefault(require("./templates/85/Template85"));

var _Template103 = _interopRequireDefault(require("./templates/86/Template86"));

var _Template104 = _interopRequireDefault(require("./templates/87/Template87"));

var _Template105 = _interopRequireDefault(require("./templates/88/Template88"));

var _Template106 = _interopRequireDefault(require("./templates/89/Template89"));

var _Template107 = _interopRequireDefault(require("./templates/90/Template90"));

var _Template108 = _interopRequireDefault(require("./templates/91/Template91"));

var _Template109 = _interopRequireDefault(require("./templates/92/Template92"));

var _Template110 = _interopRequireDefault(require("./templates/93/Template93"));

var _Template111 = _interopRequireDefault(require("./templates/94/Template94"));

var _Template112 = _interopRequireDefault(require("./templates/95/Template95"));

var _Template113 = _interopRequireDefault(require("./templates/96/Template96"));

var _Template114 = _interopRequireDefault(require("./templates/97/Template97"));

var _Template115 = _interopRequireDefault(require("./templates/99/Template99"));

var _Template116 = _interopRequireDefault(require("./templates/100/Template100"));

var _Template117 = _interopRequireDefault(require("./templates/101/Template101"));

var _Template118 = _interopRequireDefault(require("./templates/102/Template102"));

var _Template119 = _interopRequireDefault(require("./templates/103/Template103"));

var _Template120 = _interopRequireDefault(require("./templates/104/Template104"));

var _Template121 = _interopRequireDefault(require("./templates/106/Template106"));

var _Template122 = _interopRequireDefault(require("./templates/107/Template107"));

var _Template123 = _interopRequireDefault(require("./templates/108/Template108"));

var _Template124 = _interopRequireDefault(require("./templates/109/Template109"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var animation02Map = {
  Animation02_L: function Animation02_L(animation) {
    return new _Animation.default(animation);
  },
  Animation02_C: function Animation02_C(animation) {
    return new _Animation.default(animation);
  },
  Animation02_R: function Animation02_R(animation) {
    return new _Animation.default(animation);
  }
};
var animation03Map = {
  Animation03_L: function Animation03_L(animation) {
    return new _Animation2.default(animation);
  },
  Animation03_C: function Animation03_C(animation) {
    return new _Animation2.default(animation);
  },
  Animation03_R: function Animation03_R(animation) {
    return new _Animation2.default(animation);
  }
};
var animation04Map = {
  Animation04_L: function Animation04_L(animation) {
    return new _Animation3.default(animation);
  },
  Animation04_C: function Animation04_C(animation) {
    return new _Animation3.default(animation);
  },
  Animation04_R: function Animation04_R(animation) {
    return new _Animation3.default(animation);
  }
};
var animation05Map = {
  Animation05_L: function Animation05_L(animation) {
    return new _Animation4.default(animation);
  },
  Animation05_C: function Animation05_C(animation) {
    return new _Animation4.default(animation);
  },
  Animation05_R: function Animation05_R(animation) {
    return new _Animation4.default(animation);
  }
};
var animation06Map = {
  Animation06_L: function Animation06_L(animation) {
    return new _Animation5.default(animation);
  },
  Animation06_C: function Animation06_C(animation) {
    return new _Animation5.default(animation);
  },
  Animation06_R: function Animation06_R(animation) {
    return new _Animation5.default(animation);
  }
};
var animation08Map = {
  Animation08_L: function Animation08_L(animation) {
    return new _Animation6.default(animation);
  },
  Animation08_C: function Animation08_C(animation) {
    return new _Animation6.default(animation);
  },
  Animation08_R: function Animation08_R(animation) {
    return new _Animation6.default(animation);
  }
};
var animation10Map = {
  Animation10_L: function Animation10_L(animation) {
    return new _Animation7.default(animation);
  },
  Animation10_C: function Animation10_C(animation) {
    return new _Animation7.default(animation);
  },
  Animation10_R: function Animation10_R(animation) {
    return new _Animation7.default(animation);
  }
};
var animation12Map = {
  Animation12_L: function Animation12_L(animation) {
    return new _Animation8.default(animation);
  },
  Animation12_C: function Animation12_C(animation) {
    return new _Animation8.default(animation);
  },
  Animation12_R: function Animation12_R(animation) {
    return new _Animation8.default(animation);
  }
};
var animation13Map = {
  Animation13_L: function Animation13_L(animation) {
    return new _Animation9.default(animation);
  },
  Animation13_C: function Animation13_C(animation) {
    return new _Animation9.default(animation);
  },
  Animation13_R: function Animation13_R(animation) {
    return new _Animation9.default(animation);
  }
};
var animation14Map = {
  Animation14_L: function Animation14_L(animation) {
    return new _Animation10.default(animation);
  },
  Animation14_C: function Animation14_C(animation) {
    return new _Animation10.default(animation);
  },
  Animation14_R: function Animation14_R(animation) {
    return new _Animation10.default(animation);
  }
};
var animation17Map = {
  Animation17_L: function Animation17_L(animation) {
    return new _Animation11.default(animation);
  },
  Animation17_C: function Animation17_C(animation) {
    return new _Animation11.default(animation);
  },
  Animation17_R: function Animation17_R(animation) {
    return new _Animation11.default(animation);
  }
};
var animation18Map = {
  Animation18_L: function Animation18_L(animation) {
    return new _Animation12.default(animation);
  },
  Animation18_C: function Animation18_C(animation) {
    return new _Animation12.default(animation);
  },
  Animation18_R: function Animation18_R(animation) {
    return new _Animation12.default(animation);
  }
};
var animation19Map = {
  Animation19_L: function Animation19_L(animation) {
    return new _Animation13.default(animation);
  },
  Animation19_C: function Animation19_C(animation) {
    return new _Animation13.default(animation);
  },
  Animation19_R: function Animation19_R(animation) {
    return new _Animation13.default(animation);
  }
};
var animation20Map = {
  Animation20_L: function Animation20_L(animation) {
    return new _Animation14.default(animation);
  },
  Animation20_C: function Animation20_C(animation) {
    return new _Animation14.default(animation);
  },
  Animation20_R: function Animation20_R(animation) {
    return new _Animation14.default(animation);
  }
};
var animation21Map = {
  Animation21_L: function Animation21_L(animation) {
    return new _Animation15.default(animation);
  },
  Animation21_C: function Animation21_C(animation) {
    return new _Animation15.default(animation);
  },
  Animation21_R: function Animation21_R(animation) {
    return new _Animation15.default(animation);
  }
};
var animation23Map = {
  Animation23_L: function Animation23_L(animation) {
    return new _Animation16.default(animation);
  },
  Animation23_C: function Animation23_C(animation) {
    return new _Animation16.default(animation);
  },
  Animation23_R: function Animation23_R(animation) {
    return new _Animation16.default(animation);
  }
};
var animation24Map = {
  Animation24_L: function Animation24_L(animation) {
    return new _Animation17.default(animation);
  },
  Animation24_C: function Animation24_C(animation) {
    return new _Animation17.default(animation);
  },
  Animation24_R: function Animation24_R(animation) {
    return new _Animation17.default(animation);
  }
};
var animation25Map = {
  Animation25_L: function Animation25_L(animation) {
    return new _Animation18.default(animation);
  },
  Animation25_C: function Animation25_C(animation) {
    return new _Animation18.default(animation);
  },
  Animation25_R: function Animation25_R(animation) {
    return new _Animation18.default(animation);
  }
};
var animation28Map = {
  Animation28_L: function Animation28_L(animation) {
    return new _Animation19.default(animation);
  },
  Animation28_C: function Animation28_C(animation) {
    return new _Animation19.default(animation);
  },
  Animation28_R: function Animation28_R(animation) {
    return new _Animation19.default(animation);
  }
};
var animation29Map = {
  Animation29_L: function Animation29_L(animation) {
    return new _Animation20.default(animation);
  },
  Animation29_C: function Animation29_C(animation) {
    return new _Animation20.default(animation);
  },
  Animation29_R: function Animation29_R(animation) {
    return new _Animation20.default(animation);
  }
};
var animation31Map = {
  Animation31_L: function Animation31_L(animation) {
    return new _Animation21.default(animation);
  },
  Animation31_C: function Animation31_C(animation) {
    return new _Animation21.default(animation);
  },
  Animation31_R: function Animation31_R(animation) {
    return new _Animation21.default(animation);
  }
};
var animation33Map = {
  Animation33_L: function Animation33_L(animation) {
    return new _Animation22.default(animation);
  },
  Animation33_C: function Animation33_C(animation) {
    return new _Animation22.default(animation);
  },
  Animation33_R: function Animation33_R(animation) {
    return new _Animation22.default(animation);
  }
};
var animation39Map = {
  Animation39_L: function Animation39_L(animation) {
    return new _Animation23.default(animation);
  },
  Animation39_C: function Animation39_C(animation) {
    return new _Animation23.default(animation);
  },
  Animation39_R: function Animation39_R(animation) {
    return new _Animation23.default(animation);
  }
};
var animation40Map = {
  Animation40_L: function Animation40_L(animation) {
    return new _Animation24.default(animation);
  },
  Animation40_C: function Animation40_C(animation) {
    return new _Animation24.default(animation);
  },
  Animation40_R: function Animation40_R(animation) {
    return new _Animation24.default(animation);
  }
};
var animation41Map = {
  Animation41_L: function Animation41_L(animation) {
    return new _Animation25.default(animation);
  },
  Animation41_C: function Animation41_C(animation) {
    return new _Animation25.default(animation);
  },
  Animation41_R: function Animation41_R(animation) {
    return new _Animation25.default(animation);
  }
};
var animation42Map = {
  Animation42_L: function Animation42_L(animation) {
    return new _Animation26.default(animation);
  },
  Animation42_C: function Animation42_C(animation) {
    return new _Animation26.default(animation);
  },
  Animation42_R: function Animation42_R(animation) {
    return new _Animation26.default(animation);
  }
};
var animation43Map = {
  Animation43_L: function Animation43_L(animation) {
    return new _Animation27.default(animation);
  },
  Animation43_C: function Animation43_C(animation) {
    return new _Animation27.default(animation);
  },
  Animation43_R: function Animation43_R(animation) {
    return new _Animation27.default(animation);
  }
};
var animation44Map = {
  Animation44_L: function Animation44_L(animation) {
    return new _Animation28.default(animation);
  },
  Animation44_C: function Animation44_C(animation) {
    return new _Animation28.default(animation);
  },
  Animation44_R: function Animation44_R(animation) {
    return new _Animation28.default(animation);
  }
};
var animation45Map = {
  Animation45_L: function Animation45_L(animation) {
    return new _Animation29.default(animation);
  },
  Animation45_C: function Animation45_C(animation) {
    return new _Animation29.default(animation);
  },
  Animation45_R: function Animation45_R(animation) {
    return new _Animation29.default(animation);
  }
};
var animation46Map = {
  Animation46_L: function Animation46_L(animation) {
    return new _Animation30.default(animation);
  },
  Animation46_C: function Animation46_C(animation) {
    return new _Animation30.default(animation);
  },
  Animation46_R: function Animation46_R(animation) {
    return new _Animation30.default(animation);
  }
};
var animation47Map = {
  Animation47_L: function Animation47_L(animation) {
    return new _Animation31.default(animation);
  },
  Animation47_C: function Animation47_C(animation) {
    return new _Animation31.default(animation);
  },
  Animation47_R: function Animation47_R(animation) {
    return new _Animation31.default(animation);
  }
};
var animation48Map = {
  Animation48_L: function Animation48_L(animation) {
    return new _Animation32.default(animation);
  },
  Animation48_C: function Animation48_C(animation) {
    return new _Animation32.default(animation);
  },
  Animation48_R: function Animation48_R(animation) {
    return new _Animation32.default(animation);
  }
};
var animation50Map = {
  Animation50_widescreen_C: function Animation50_widescreen_C(animation) {
    return new _Animation33.default(animation);
  },
  Animation50_square_C: function Animation50_square_C(animation) {
    return new _Animation33.default(animation);
  },
  Animation50_vertical_C: function Animation50_vertical_C(animation) {
    return new _Animation33.default(animation);
  },
  Animation50_widescreen_L: function Animation50_widescreen_L(animation) {
    return new _Animation33.default(animation);
  },
  Animation50_square_L: function Animation50_square_L(animation) {
    return new _Animation33.default(animation);
  },
  Animation50_vertical_L: function Animation50_vertical_L(animation) {
    return new _Animation33.default(animation);
  },
  Animation50_widescreen_R: function Animation50_widescreen_R(animation) {
    return new _Animation33.default(animation);
  },
  Animation50_square_R: function Animation50_square_R(animation) {
    return new _Animation33.default(animation);
  },
  Animation50_vertical_R: function Animation50_vertical_R(animation) {
    return new _Animation33.default(animation);
  }
};
var animation51Map = {
  Animation51_widescreen_C: function Animation51_widescreen_C(animation) {
    return new _Animation34.default(animation);
  },
  Animation51_square_C: function Animation51_square_C(animation) {
    return new _Animation34.default(animation);
  },
  Animation51_vertical_C: function Animation51_vertical_C(animation) {
    return new _Animation34.default(animation);
  },
  Animation51_widescreen_L: function Animation51_widescreen_L(animation) {
    return new _Animation34.default(animation);
  },
  Animation51_square_L: function Animation51_square_L(animation) {
    return new _Animation34.default(animation);
  },
  Animation51_vertical_L: function Animation51_vertical_L(animation) {
    return new _Animation34.default(animation);
  },
  Animation51_widescreen_R: function Animation51_widescreen_R(animation) {
    return new _Animation34.default(animation);
  },
  Animation51_square_R: function Animation51_square_R(animation) {
    return new _Animation34.default(animation);
  },
  Animation51_vertical_R: function Animation51_vertical_R(animation) {
    return new _Animation34.default(animation);
  }
};
var animation52Map = {
  Animation52_widescreen_C: function Animation52_widescreen_C(animation) {
    return new _Animation35.default(animation);
  },
  Animation52_square_C: function Animation52_square_C(animation) {
    return new _Animation35.default(animation);
  },
  Animation52_vertical_C: function Animation52_vertical_C(animation) {
    return new _Animation35.default(animation);
  },
  Animation52_widescreen_L: function Animation52_widescreen_L(animation) {
    return new _Animation35.default(animation);
  },
  Animation52_square_L: function Animation52_square_L(animation) {
    return new _Animation35.default(animation);
  },
  Animation52_vertical_L: function Animation52_vertical_L(animation) {
    return new _Animation35.default(animation);
  },
  Animation52_widescreen_R: function Animation52_widescreen_R(animation) {
    return new _Animation35.default(animation);
  },
  Animation52_square_R: function Animation52_square_R(animation) {
    return new _Animation35.default(animation);
  },
  Animation52_vertical_R: function Animation52_vertical_R(animation) {
    return new _Animation35.default(animation);
  }
};
var animation53Map = {
  Animation53_L: function Animation53_L(animation) {
    return new _Animation36.default(animation);
  },
  Animation53_C: function Animation53_C(animation) {
    return new _Animation36.default(animation);
  },
  Animation53_R: function Animation53_R(animation) {
    return new _Animation36.default(animation);
  }
};
var animation55Map = {
  Animation55_L: function Animation55_L(animation) {
    return new _Animation37.default(animation);
  },
  Animation55_C: function Animation55_C(animation) {
    return new _Animation37.default(animation);
  },
  Animation55_R: function Animation55_R(animation) {
    return new _Animation37.default(animation);
  }
};
var animation56Map = {
  Animation56_L: function Animation56_L(animation) {
    return new _Animation38.default(animation);
  },
  Animation56_C: function Animation56_C(animation) {
    return new _Animation38.default(animation);
  },
  Animation56_R: function Animation56_R(animation) {
    return new _Animation38.default(animation);
  }
};
var animation58Map = {
  Animation58_L: function Animation58_L(animation) {
    return new _Animation39.default(animation);
  },
  Animation58_C: function Animation58_C(animation) {
    return new _Animation39.default(animation);
  },
  Animation58_R: function Animation58_R(animation) {
    return new _Animation39.default(animation);
  }
};
var animation59Map = {
  Animation59_L: function Animation59_L(animation) {
    return new _Animation40.default(animation);
  },
  Animation59_C: function Animation59_C(animation) {
    return new _Animation40.default(animation);
  },
  Animation59_R: function Animation59_R(animation) {
    return new _Animation40.default(animation);
  }
};
var animation60Map = {
  Animation60_widescreen_C: function Animation60_widescreen_C(animation) {
    return new _Animation41.default(animation);
  },
  Animation60_square_C: function Animation60_square_C(animation) {
    return new _Animation41.default(animation);
  },
  Animation60_vertical_C: function Animation60_vertical_C(animation) {
    return new _Animation41.default(animation);
  },
  Animation60_widescreen_L: function Animation60_widescreen_L(animation) {
    return new _Animation41.default(animation);
  },
  Animation60_square_L: function Animation60_square_L(animation) {
    return new _Animation41.default(animation);
  },
  Animation60_vertical_L: function Animation60_vertical_L(animation) {
    return new _Animation41.default(animation);
  },
  Animation60_widescreen_R: function Animation60_widescreen_R(animation) {
    return new _Animation41.default(animation);
  },
  Animation60_square_R: function Animation60_square_R(animation) {
    return new _Animation41.default(animation);
  },
  Animation60_vertical_R: function Animation60_vertical_R(animation) {
    return new _Animation41.default(animation);
  }
};
var animation61Map = {
  Animation61_widescreen_C: function Animation61_widescreen_C(animation) {
    return new _Animation42.default(animation);
  },
  Animation61_square_C: function Animation61_square_C(animation) {
    return new _Animation42.default(animation);
  },
  Animation61_vertical_C: function Animation61_vertical_C(animation) {
    return new _Animation42.default(animation);
  },
  Animation61_widescreen_L: function Animation61_widescreen_L(animation) {
    return new _Animation42.default(animation);
  },
  Animation61_square_L: function Animation61_square_L(animation) {
    return new _Animation42.default(animation);
  },
  Animation61_vertical_L: function Animation61_vertical_L(animation) {
    return new _Animation42.default(animation);
  },
  Animation61_widescreen_R: function Animation61_widescreen_R(animation) {
    return new _Animation42.default(animation);
  },
  Animation61_square_R: function Animation61_square_R(animation) {
    return new _Animation42.default(animation);
  },
  Animation61_vertical_R: function Animation61_vertical_R(animation) {
    return new _Animation42.default(animation);
  }
};
var animation62Map = {
  Animation62_widescreen_C: function Animation62_widescreen_C(animation) {
    return new _Animation43.default(animation);
  },
  Animation62_square_C: function Animation62_square_C(animation) {
    return new _Animation43.default(animation);
  },
  Animation62_vertical_C: function Animation62_vertical_C(animation) {
    return new _Animation43.default(animation);
  },
  Animation62_widescreen_L: function Animation62_widescreen_L(animation) {
    return new _Animation43.default(animation);
  },
  Animation62_square_L: function Animation62_square_L(animation) {
    return new _Animation43.default(animation);
  },
  Animation62_vertical_L: function Animation62_vertical_L(animation) {
    return new _Animation43.default(animation);
  },
  Animation62_widescreen_R: function Animation62_widescreen_R(animation) {
    return new _Animation43.default(animation);
  },
  Animation62_square_R: function Animation62_square_R(animation) {
    return new _Animation43.default(animation);
  },
  Animation62_vertical_R: function Animation62_vertical_R(animation) {
    return new _Animation43.default(animation);
  }
};
var animation63Map = {
  Animation63_L: function Animation63_L(animation) {
    return new _Animation44.default(animation);
  },
  Animation63_C: function Animation63_C(animation) {
    return new _Animation44.default(animation);
  },
  Animation63_R: function Animation63_R(animation) {
    return new _Animation44.default(animation);
  }
};
var animation64Map = {
  Animation64_L: function Animation64_L(animation) {
    return new _Animation45.default(animation);
  },
  Animation64_C: function Animation64_C(animation) {
    return new _Animation45.default(animation);
  },
  Animation64_R: function Animation64_R(animation) {
    return new _Animation45.default(animation);
  }
};
var animation65Map = {
  Animation65_widescreen_C: function Animation65_widescreen_C(animation) {
    return new _Animation46.default(animation);
  },
  Animation65_square_C: function Animation65_square_C(animation) {
    return new _Animation46.default(animation);
  },
  Animation65_vertical_C: function Animation65_vertical_C(animation) {
    return new _Animation46.default(animation);
  },
  Animation65_widescreen_L: function Animation65_widescreen_L(animation) {
    return new _Animation46.default(animation);
  },
  Animation65_square_L: function Animation65_square_L(animation) {
    return new _Animation46.default(animation);
  },
  Animation65_vertical_L: function Animation65_vertical_L(animation) {
    return new _Animation46.default(animation);
  },
  Animation65_widescreen_R: function Animation65_widescreen_R(animation) {
    return new _Animation46.default(animation);
  },
  Animation65_square_R: function Animation65_square_R(animation) {
    return new _Animation46.default(animation);
  },
  Animation65_vertical_R: function Animation65_vertical_R(animation) {
    return new _Animation46.default(animation);
  }
};
var animation66Map = {
  Animation66_widescreen_C: function Animation66_widescreen_C(animation) {
    return new _Animation47.default(animation);
  },
  Animation66_square_C: function Animation66_square_C(animation) {
    return new _Animation47.default(animation);
  },
  Animation66_vertical_C: function Animation66_vertical_C(animation) {
    return new _Animation47.default(animation);
  },
  Animation66_widescreen_L: function Animation66_widescreen_L(animation) {
    return new _Animation47.default(animation);
  },
  Animation66_square_L: function Animation66_square_L(animation) {
    return new _Animation47.default(animation);
  },
  Animation66_vertical_L: function Animation66_vertical_L(animation) {
    return new _Animation47.default(animation);
  },
  Animation66_widescreen_R: function Animation66_widescreen_R(animation) {
    return new _Animation47.default(animation);
  },
  Animation66_square_R: function Animation66_square_R(animation) {
    return new _Animation47.default(animation);
  },
  Animation66_vertical_R: function Animation66_vertical_R(animation) {
    return new _Animation47.default(animation);
  }
};
var animation67Map = {
  Animation67_L: function Animation67_L(animation) {
    return new _Animation48.default(animation);
  },
  Animation67_C: function Animation67_C(animation) {
    return new _Animation48.default(animation);
  },
  Animation67_R: function Animation67_R(animation) {
    return new _Animation48.default(animation);
  }
};
var animation68Map = {
  Animation68_L: function Animation68_L(animation) {
    return new _Animation49.default(animation);
  },
  Animation68_C: function Animation68_C(animation) {
    return new _Animation49.default(animation);
  },
  Animation68_R: function Animation68_R(animation) {
    return new _Animation49.default(animation);
  }
};
var animation69Map = {
  Animation69_L: function Animation69_L(animation) {
    return new _Animation50.default(animation);
  },
  Animation69_C: function Animation69_C(animation) {
    return new _Animation50.default(animation);
  },
  Animation69_R: function Animation69_R(animation) {
    return new _Animation50.default(animation);
  }
};
var animation70Map = {
  Animation70_L: function Animation70_L(animation) {
    return new _Animation51.default(animation);
  },
  Animation70_C: function Animation70_C(animation) {
    return new _Animation51.default(animation);
  },
  Animation70_R: function Animation70_R(animation) {
    return new _Animation51.default(animation);
  }
};
var AnimationTrustPilot01Map = {
  AnimationTrustPilot01_L: function AnimationTrustPilot01_L(animation) {
    return new _AnimationTrustPilot.default(animation);
  }
};
var outro01Map = {
  Outro01_widescreen_C: function Outro01_widescreen_C(animation) {
    return new _Outro.default(animation);
  },
  Outro01_square_C: function Outro01_square_C(animation) {
    return new _Outro.default(animation);
  },
  Outro01_vertical_C: function Outro01_vertical_C(animation) {
    return new _Outro.default(animation);
  },
  Outro01_widescreen_L: function Outro01_widescreen_L(animation) {
    return new _Outro.default(animation);
  },
  Outro01_square_L: function Outro01_square_L(animation) {
    return new _Outro.default(animation);
  },
  Outro01_vertical_L: function Outro01_vertical_L(animation) {
    return new _Outro.default(animation);
  },
  Outro01_widescreen_R: function Outro01_widescreen_R(animation) {
    return new _Outro.default(animation);
  },
  Outro01_square_R: function Outro01_square_R(animation) {
    return new _Outro.default(animation);
  },
  Outro01_vertical_R: function Outro01_vertical_R(animation) {
    return new _Outro.default(animation);
  }
};
var outro03Map = {
  Outro03_widescreen_C: function Outro03_widescreen_C(animation) {
    return new _Outro2.default(animation);
  },
  Outro03_square_C: function Outro03_square_C(animation) {
    return new _Outro2.default(animation);
  },
  Outro03_vertical_C: function Outro03_vertical_C(animation) {
    return new _Outro2.default(animation);
  },
  Outro03_widescreen_L: function Outro03_widescreen_L(animation) {
    return new _Outro2.default(animation);
  },
  Outro03_square_L: function Outro03_square_L(animation) {
    return new _Outro2.default(animation);
  },
  Outro03_vertical_L: function Outro03_vertical_L(animation) {
    return new _Outro2.default(animation);
  },
  Outro03_widescreen_R: function Outro03_widescreen_R(animation) {
    return new _Outro2.default(animation);
  },
  Outro03_square_R: function Outro03_square_R(animation) {
    return new _Outro2.default(animation);
  },
  Outro03_vertical_R: function Outro03_vertical_R(animation) {
    return new _Outro2.default(animation);
  }
};
var outro04Map = {
  Outro04_widescreen_C: function Outro04_widescreen_C(animation) {
    return new _Outro3.default(animation);
  },
  Outro04_square_C: function Outro04_square_C(animation) {
    return new _Outro3.default(animation);
  },
  Outro04_vertical_C: function Outro04_vertical_C(animation) {
    return new _Outro3.default(animation);
  },
  Outro04_widescreen_L: function Outro04_widescreen_L(animation) {
    return new _Outro3.default(animation);
  },
  Outro04_square_L: function Outro04_square_L(animation) {
    return new _Outro3.default(animation);
  },
  Outro04_vertical_L: function Outro04_vertical_L(animation) {
    return new _Outro3.default(animation);
  },
  Outro04_widescreen_R: function Outro04_widescreen_R(animation) {
    return new _Outro3.default(animation);
  },
  Outro04_square_R: function Outro04_square_R(animation) {
    return new _Outro3.default(animation);
  },
  Outro04_vertical_R: function Outro04_vertical_R(animation) {
    return new _Outro3.default(animation);
  }
};
var outro05Map = {
  Outro05_widescreen_C: function Outro05_widescreen_C(animation) {
    return new _Outro4.default(animation);
  },
  Outro05_square_C: function Outro05_square_C(animation) {
    return new _Outro4.default(animation);
  },
  Outro05_vertical_C: function Outro05_vertical_C(animation) {
    return new _Outro4.default(animation);
  },
  Outro05_widescreen_L: function Outro05_widescreen_L(animation) {
    return new _Outro4.default(animation);
  },
  Outro05_square_L: function Outro05_square_L(animation) {
    return new _Outro4.default(animation);
  },
  Outro05_vertical_L: function Outro05_vertical_L(animation) {
    return new _Outro4.default(animation);
  },
  Outro05_widescreen_R: function Outro05_widescreen_R(animation) {
    return new _Outro4.default(animation);
  },
  Outro05_square_R: function Outro05_square_R(animation) {
    return new _Outro4.default(animation);
  },
  Outro05_vertical_R: function Outro05_vertical_R(animation) {
    return new _Outro4.default(animation);
  }
};
var outro06Map = {
  Outro06_widescreen_L: function Outro06_widescreen_L(animation) {
    return new _Outro5.default(animation);
  },
  Outro06_square_L: function Outro06_square_L(animation) {
    return new _Outro5.default(animation);
  },
  Outro06_vertical_L: function Outro06_vertical_L(animation) {
    return new _Outro5.default(animation);
  },
  Outro06_widescreen_C: function Outro06_widescreen_C(animation) {
    return new _Outro5.default(animation);
  },
  Outro06_square_C: function Outro06_square_C(animation) {
    return new _Outro5.default(animation);
  },
  Outro06_vertical_C: function Outro06_vertical_C(animation) {
    return new _Outro5.default(animation);
  },
  Outro06_widescreen_R: function Outro06_widescreen_R(animation) {
    return new _Outro5.default(animation);
  },
  Outro06_square_R: function Outro06_square_R(animation) {
    return new _Outro5.default(animation);
  },
  Outro06_vertical_R: function Outro06_vertical_R(animation) {
    return new _Outro5.default(animation);
  }
};
var outro07Map = {
  Outro07_widescreen_L: function Outro07_widescreen_L(animation) {
    return new _Outro6.default(animation);
  },
  Outro07_square_L: function Outro07_square_L(animation) {
    return new _Outro6.default(animation);
  },
  Outro07_vertical_L: function Outro07_vertical_L(animation) {
    return new _Outro6.default(animation);
  },
  Outro07_widescreen_C: function Outro07_widescreen_C(animation) {
    return new _Outro6.default(animation);
  },
  Outro07_square_C: function Outro07_square_C(animation) {
    return new _Outro6.default(animation);
  },
  Outro07_vertical_C: function Outro07_vertical_C(animation) {
    return new _Outro6.default(animation);
  },
  Outro07_widescreen_R: function Outro07_widescreen_R(animation) {
    return new _Outro6.default(animation);
  },
  Outro07_square_R: function Outro07_square_R(animation) {
    return new _Outro6.default(animation);
  },
  Outro07_vertical_R: function Outro07_vertical_R(animation) {
    return new _Outro6.default(animation);
  }
};
var outro08Map = {
  Outro08_widescreen_L: function Outro08_widescreen_L(animation) {
    return new _Outro7.default(animation);
  },
  Outro08_square_L: function Outro08_square_L(animation) {
    return new _Outro7.default(animation);
  },
  Outro08_vertical_L: function Outro08_vertical_L(animation) {
    return new _Outro7.default(animation);
  },
  Outro08_widescreen_C: function Outro08_widescreen_C(animation) {
    return new _Outro7.default(animation);
  },
  Outro08_square_C: function Outro08_square_C(animation) {
    return new _Outro7.default(animation);
  },
  Outro08_vertical_C: function Outro08_vertical_C(animation) {
    return new _Outro7.default(animation);
  },
  Outro08_widescreen_R: function Outro08_widescreen_R(animation) {
    return new _Outro7.default(animation);
  },
  Outro08_square_R: function Outro08_square_R(animation) {
    return new _Outro7.default(animation);
  },
  Outro08_vertical_R: function Outro08_vertical_R(animation) {
    return new _Outro7.default(animation);
  }
};
var outro09Map = {
  Outro09_widescreen_L: function Outro09_widescreen_L(animation) {
    return new _Outro8.default(animation);
  },
  Outro09_square_L: function Outro09_square_L(animation) {
    return new _Outro8.default(animation);
  },
  Outro09_vertical_L: function Outro09_vertical_L(animation) {
    return new _Outro8.default(animation);
  },
  Outro09_widescreen_C: function Outro09_widescreen_C(animation) {
    return new _Outro8.default(animation);
  },
  Outro09_square_C: function Outro09_square_C(animation) {
    return new _Outro8.default(animation);
  },
  Outro09_vertical_C: function Outro09_vertical_C(animation) {
    return new _Outro8.default(animation);
  },
  Outro09_widescreen_R: function Outro09_widescreen_R(animation) {
    return new _Outro8.default(animation);
  },
  Outro09_square_R: function Outro09_square_R(animation) {
    return new _Outro8.default(animation);
  },
  Outro09_vertical_R: function Outro09_vertical_R(animation) {
    return new _Outro8.default(animation);
  }
};
var outro10Map = {
  Outro10_widescreen_L: function Outro10_widescreen_L(animation) {
    return new _Outro9.default(animation);
  },
  Outro10_square_L: function Outro10_square_L(animation) {
    return new _Outro9.default(animation);
  },
  Outro10_vertical_L: function Outro10_vertical_L(animation) {
    return new _Outro9.default(animation);
  },
  Outro10_widescreen_C: function Outro10_widescreen_C(animation) {
    return new _Outro9.default(animation);
  },
  Outro10_square_C: function Outro10_square_C(animation) {
    return new _Outro9.default(animation);
  },
  Outro10_vertical_C: function Outro10_vertical_C(animation) {
    return new _Outro9.default(animation);
  },
  Outro10_widescreen_R: function Outro10_widescreen_R(animation) {
    return new _Outro9.default(animation);
  },
  Outro10_square_R: function Outro10_square_R(animation) {
    return new _Outro9.default(animation);
  },
  Outro10_vertical_R: function Outro10_vertical_R(animation) {
    return new _Outro9.default(animation);
  }
};
var outro11Map = {
  Outro11_widescreen_L: function Outro11_widescreen_L(animation) {
    return new _Outro10.default(animation);
  },
  Outro11_square_L: function Outro11_square_L(animation) {
    return new _Outro10.default(animation);
  },
  Outro11_vertical_L: function Outro11_vertical_L(animation) {
    return new _Outro10.default(animation);
  },
  Outro11_widescreen_C: function Outro11_widescreen_C(animation) {
    return new _Outro10.default(animation);
  },
  Outro11_square_C: function Outro11_square_C(animation) {
    return new _Outro10.default(animation);
  },
  Outro11_vertical_C: function Outro11_vertical_C(animation) {
    return new _Outro10.default(animation);
  },
  Outro11_widescreen_R: function Outro11_widescreen_R(animation) {
    return new _Outro10.default(animation);
  },
  Outro11_square_R: function Outro11_square_R(animation) {
    return new _Outro10.default(animation);
  },
  Outro11_vertical_R: function Outro11_vertical_R(animation) {
    return new _Outro10.default(animation);
  }
};
var outro15Map = {
  Outro15_widescreen_L: function Outro15_widescreen_L(animation) {
    return new _Outro11.default(animation);
  },
  Outro15_square_L: function Outro15_square_L(animation) {
    return new _Outro11.default(animation);
  },
  Outro15_vertical_L: function Outro15_vertical_L(animation) {
    return new _Outro11.default(animation);
  },
  Outro15_widescreen_C: function Outro15_widescreen_C(animation) {
    return new _Outro11.default(animation);
  },
  Outro15_square_C: function Outro15_square_C(animation) {
    return new _Outro11.default(animation);
  },
  Outro15_vertical_C: function Outro15_vertical_C(animation) {
    return new _Outro11.default(animation);
  },
  Outro15_widescreen_R: function Outro15_widescreen_R(animation) {
    return new _Outro11.default(animation);
  },
  Outro15_square_R: function Outro15_square_R(animation) {
    return new _Outro11.default(animation);
  },
  Outro15_vertical_R: function Outro15_vertical_R(animation) {
    return new _Outro11.default(animation);
  }
};
var outro21Map = {
  Outro21_widescreen_L: function Outro21_widescreen_L(animation) {
    return new _Outro12.default(animation);
  },
  Outro21_square_L: function Outro21_square_L(animation) {
    return new _Outro12.default(animation);
  },
  Outro21_vertical_L: function Outro21_vertical_L(animation) {
    return new _Outro12.default(animation);
  },
  Outro21_widescreen_C: function Outro21_widescreen_C(animation) {
    return new _Outro12.default(animation);
  },
  Outro21_square_C: function Outro21_square_C(animation) {
    return new _Outro12.default(animation);
  },
  Outro21_vertical_C: function Outro21_vertical_C(animation) {
    return new _Outro12.default(animation);
  },
  Outro21_widescreen_R: function Outro21_widescreen_R(animation) {
    return new _Outro12.default(animation);
  },
  Outro21_square_R: function Outro21_square_R(animation) {
    return new _Outro12.default(animation);
  },
  Outro21_vertical_R: function Outro21_vertical_R(animation) {
    return new _Outro12.default(animation);
  }
};
var outro22Map = {
  Outro22_widescreen_L: function Outro22_widescreen_L(animation) {
    return new _Outro13.default(animation);
  },
  Outro22_square_L: function Outro22_square_L(animation) {
    return new _Outro13.default(animation);
  },
  Outro22_vertical_L: function Outro22_vertical_L(animation) {
    return new _Outro13.default(animation);
  },
  Outro22_widescreen_C: function Outro22_widescreen_C(animation) {
    return new _Outro13.default(animation);
  },
  Outro22_square_C: function Outro22_square_C(animation) {
    return new _Outro13.default(animation);
  },
  Outro22_vertical_C: function Outro22_vertical_C(animation) {
    return new _Outro13.default(animation);
  },
  Outro22_widescreen_R: function Outro22_widescreen_R(animation) {
    return new _Outro13.default(animation);
  },
  Outro22_square_R: function Outro22_square_R(animation) {
    return new _Outro13.default(animation);
  },
  Outro22_vertical_R: function Outro22_vertical_R(animation) {
    return new _Outro13.default(animation);
  }
};
var outro25Map = {
  Outro25_widescreen_L: function Outro25_widescreen_L(animation) {
    return new _Outro14.default(animation);
  },
  Outro25_square_L: function Outro25_square_L(animation) {
    return new _Outro14.default(animation);
  },
  Outro25_vertical_L: function Outro25_vertical_L(animation) {
    return new _Outro14.default(animation);
  },
  Outro25_widescreen_C: function Outro25_widescreen_C(animation) {
    return new _Outro14.default(animation);
  },
  Outro25_square_C: function Outro25_square_C(animation) {
    return new _Outro14.default(animation);
  },
  Outro25_vertical_C: function Outro25_vertical_C(animation) {
    return new _Outro14.default(animation);
  },
  Outro25_widescreen_R: function Outro25_widescreen_R(animation) {
    return new _Outro14.default(animation);
  },
  Outro25_square_R: function Outro25_square_R(animation) {
    return new _Outro14.default(animation);
  },
  Outro25_vertical_R: function Outro25_vertical_R(animation) {
    return new _Outro14.default(animation);
  }
};
var outro26Map = {
  Outro26_widescreen_L: function Outro26_widescreen_L(animation) {
    return new _Outro15.default(animation);
  },
  Outro26_square_L: function Outro26_square_L(animation) {
    return new _Outro15.default(animation);
  },
  Outro26_vertical_L: function Outro26_vertical_L(animation) {
    return new _Outro15.default(animation);
  },
  Outro26_widescreen_C: function Outro26_widescreen_C(animation) {
    return new _Outro15.default(animation);
  },
  Outro26_square_C: function Outro26_square_C(animation) {
    return new _Outro15.default(animation);
  },
  Outro26_vertical_C: function Outro26_vertical_C(animation) {
    return new _Outro15.default(animation);
  },
  Outro26_widescreen_R: function Outro26_widescreen_R(animation) {
    return new _Outro15.default(animation);
  },
  Outro26_square_R: function Outro26_square_R(animation) {
    return new _Outro15.default(animation);
  },
  Outro26_vertical_R: function Outro26_vertical_R(animation) {
    return new _Outro15.default(animation);
  }
};
var outro27Map = {
  Outro27_widescreen_L: function Outro27_widescreen_L(animation) {
    return new _Outro16.default(animation);
  },
  Outro27_square_L: function Outro27_square_L(animation) {
    return new _Outro16.default(animation);
  },
  Outro27_vertical_L: function Outro27_vertical_L(animation) {
    return new _Outro16.default(animation);
  },
  Outro27_widescreen_C: function Outro27_widescreen_C(animation) {
    return new _Outro16.default(animation);
  },
  Outro27_square_C: function Outro27_square_C(animation) {
    return new _Outro16.default(animation);
  },
  Outro27_vertical_C: function Outro27_vertical_C(animation) {
    return new _Outro16.default(animation);
  },
  Outro27_widescreen_R: function Outro27_widescreen_R(animation) {
    return new _Outro16.default(animation);
  },
  Outro27_square_R: function Outro27_square_R(animation) {
    return new _Outro16.default(animation);
  },
  Outro27_vertical_R: function Outro27_vertical_R(animation) {
    return new _Outro16.default(animation);
  }
};
var OutroTrustPilot01Map = {
  OutroTrustPilot01_widescreen_C: function OutroTrustPilot01_widescreen_C(animation) {
    return new _OutroTrustPilot.default(animation);
  },
  OutroTrustPilot01_square_C: function OutroTrustPilot01_square_C(animation) {
    return new _OutroTrustPilot.default(animation);
  },
  OutroTrustPilot01_vertical_C: function OutroTrustPilot01_vertical_C(animation) {
    return new _OutroTrustPilot.default(animation);
  }
};
var Photo01Map = {
  cut: function cut(animation) {
    return new _Photo2.default(animation);
  },
  fade: function fade(animation) {
    return new _Photo2.default(animation);
  },
  Photo01: function Photo01(animation) {
    return new _Photo2.default(animation);
  },
  Photo02: function Photo02(animation) {
    return new _Photo2.default(animation);
  },
  Photo03: function Photo03(animation) {
    return new _Photo2.default(animation);
  },
  Photo04: function Photo04(animation) {
    return new _Photo2.default(animation);
  },
  Photo05: function Photo05(animation) {
    return new _Photo2.default(animation);
  },
  Photo06: function Photo06(animation) {
    return new _Photo2.default(animation);
  },
  Photo07: function Photo07(animation) {
    return new _Photo2.default(animation);
  }
};
var AnimationUploadedMap = {
  AnimationUploaded: function AnimationUploaded(animation) {
    return new _AnimationUploaded2.default(animation);
  },
  OutroUploaded: function OutroUploaded(animation) {
    return new _OutroUploaded2.default(animation);
  }
};
var Template67Map = {
  Template67: function Template67(animation) {
    return new _Template64.default(animation);
  }
};
var Template33Map = {
  Template33: function Template33(animation) {
    return new _Template65.default(animation);
  }
};
var Template47Map = {
  Template47: function Template47(animation) {
    return new _Template66.default(animation);
  }
};
var Template62Map = {
  Template62: function Template62(animation) {
    return new _Template63.default(animation);
  }
};
var Template24Map = {
  Template24: function Template24(animation) {
    return new _Template67.default(animation);
  }
};
var Template15Map = {
  Template15: function Template15(animation) {
    return new _Template68.default(animation);
  }
};
var Template14Map = {
  Template14: function Template14(animation) {
    return new _Template69.default(animation);
  }
};
var Template12Map = {
  Template12: function Template12(animation) {
    return new _Template70.default(animation);
  }
};
var Template10Map = {
  Template10: function Template10(animation) {
    return new _Template71.default(animation);
  }
};
var Template9Map = {
  Template9: function Template9(animation) {
    return new _Template72.default(animation);
  }
};
var Template1Map = {
  Template1: function Template1(animation) {
    return new _Template73.default(animation);
  }
};
var Template13Map = {
  Template13: function Template13(animation) {
    return new _Template74.default(animation);
  }
};
/* ##### DO NOT DELETE THIS LINE: */

/* ###--ANIMATIONS-ANIMATION-FACTORY-MAP--###*/

var Template87Map = {
  Template87: function Template87(animation) {
    return new _Template104.default(animation);
  }
};
var Template88Map = {
  Template88: function Template88(animation) {
    return new _Template105.default(animation);
  }
};
var Template89Map = {
  Template89: function Template89(animation) {
    return new _Template106.default(animation);
  }
};
var Template90Map = {
  Template90: function Template90(animation) {
    return new _Template107.default(animation);
  }
};
var Template91Map = {
  Template91: function Template91(animation) {
    return new _Template108.default(animation);
  }
};
var Template92Map = {
  Template92: function Template92(animation) {
    return new _Template109.default(animation);
  }
};
var Template93Map = {
  Template93: function Template93(animation) {
    return new _Template110.default(animation);
  }
};
var Template94Map = {
  Template94: function Template94(animation) {
    return new _Template111.default(animation);
  }
};
var Template95Map = {
  Template95: function Template95(animation) {
    return new _Template112.default(animation);
  }
};
var Template96Map = {
  Template96: function Template96(animation) {
    return new _Template113.default(animation);
  }
};
var Template97Map = {
  Template97: function Template97(animation) {
    return new _Template114.default(animation);
  }
};
var Template99Map = {
  Template99: function Template99(animation) {
    return new _Template115.default(animation);
  }
};
var Template100Map = {
  Template100: function Template100(animation) {
    return new _Template116.default(animation);
  }
};
var Template101Map = {
  Template101: function Template101(animation) {
    return new _Template117.default(animation);
  }
};
var Template102Map = {
  Template102: function Template102(animation) {
    return new _Template118.default(animation);
  }
};
var Template103Map = {
  Template103: function Template103(animation) {
    return new _Template119.default(animation);
  }
};
var Template104Map = {
  Template104: function Template104(animation) {
    return new _Template120.default(animation);
  }
};
var Template106Map = {
  Template106: function Template106(animation) {
    return new _Template121.default(animation);
  }
};
var Template107Map = {
  Template107: function Template107(animation) {
    return new _Template122.default(animation);
  }
};
var Template108Map = {
  Template108: function Template108(animation) {
    return new _Template123.default(animation);
  }
};
var Template109Map = {
  Template109: function Template109(animation) {
    return new _Template124.default(animation);
  }
};
var Template86Map = {
  Template86: function Template86(animation) {
    return new _Template103.default(animation);
  }
};
var Template85Map = {
  Template85: function Template85(animation) {
    return new _Template102.default(animation);
  }
};
var Template84Map = {
  Template84: function Template84(animation) {
    return new _Template101.default(animation);
  }
};
var Template83Map = {
  Template83: function Template83(animation) {
    return new _Template100.default(animation);
  }
};
var Template81Map = {
  Template81: function Template81(animation) {
    return new _Template99.default(animation);
  }
};
var Template80Map = {
  Template80: function Template80(animation) {
    return new _Template98.default(animation);
  }
};
var Template31Map = {
  Template31: function Template31(animation) {
    return new _Template81.default(animation);
  }
};
var Template65Map = {
  Template65: function Template65(animation) {
    return new _Template95.default(animation);
  }
};
var Template61Map = {
  Template61: function Template61(animation) {
    return new _Template93.default(animation);
  }
};
var Template44Map = {
  Template44: function Template44(animation) {
    return new _Template84.default(animation);
  }
};
var Template79Map = {
  Template79: function Template79(animation) {
    return new _Template97.default(animation);
  }
};
var Template59Map = {
  Template59: function Template59(animation) {
    return new _Template91.default(animation);
  }
};
var Template58Map = {
  Template58: function Template58(animation) {
    return new _Template90.default(animation);
  }
};
var Template57Map = {
  Template57: function Template57(animation) {
    return new _Template89.default(animation);
  }
};
var Template11Map = {
  Template11: function Template11(animation) {
    return new _Template75.default(animation);
  }
};
var Template37Map = {
  Template37: function Template37(animation) {
    return new _Template82.default(animation);
  }
};
var Template63Map = {
  Template63: function Template63(animation) {
    return new _Template94.default(animation);
  }
};
var Template55Map = {
  Template55: function Template55(animation) {
    return new _Template88.default(animation);
  }
};
var Template60Map = {
  Template60: function Template60(animation) {
    return new _Template92.default(animation);
  }
};
var Template49Map = {
  Template49: function Template49(animation) {
    return new _Template87.default(animation);
  }
};
var Template48Map = {
  Template48: function Template48(animation) {
    return new _Template86.default(animation);
  }
};
var Template45Map = {
  Template45: function Template45(animation) {
    return new _Template85.default(animation);
  }
};
var Template20Map = {
  Template20: function Template20(animation) {
    return new _Template77.default(animation);
  }
};
var Template38Map = {
  Template38: function Template38(animation) {
    return new _Template83.default(animation);
  }
};
var Template29Map = {
  Template29: function Template29(animation) {
    return new _Template79.default(animation);
  }
};
var Template18Map = {
  Template18: function Template18(animation) {
    return new _Template76.default(animation);
  }
};
var Template27Map = {
  Template27: function Template27(animation) {
    return new _Template78.default(animation);
  }
};
var Template30Map = {
  Template30: function Template30(animation) {
    return new _Template80.default(animation);
  }
};
var Template71Map = {
  Template71: function Template71(animation) {
    return new _Template96.default(animation);
  }
};

var animationsMap = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, animation02Map), animation03Map), animation04Map), animation05Map), animation06Map), animation08Map), animation10Map), animation12Map), animation13Map), animation14Map), animation17Map), animation18Map), animation19Map), animation20Map), animation21Map), animation23Map), animation24Map), animation25Map), animation28Map), animation29Map), animation31Map), animation33Map), animation39Map), animation40Map), animation41Map), animation42Map), animation43Map), animation44Map), animation45Map), animation46Map), animation47Map), animation48Map), animation50Map), animation51Map), animation52Map), animation53Map), animation55Map), animation56Map), animation58Map), animation59Map), animation60Map), animation61Map), animation62Map), animation63Map), animation64Map), animation65Map), animation66Map), animation67Map), animation68Map), animation69Map), animation70Map), AnimationTrustPilot01Map), outro01Map), outro03Map), outro04Map), outro05Map), outro06Map), outro07Map), outro08Map), outro09Map), outro10Map), outro11Map), outro15Map), outro21Map), outro22Map), outro25Map), outro26Map), outro27Map), OutroTrustPilot01Map), Photo01Map), AnimationUploadedMap), Template1Map), Template9Map), Template10Map), Template11Map), Template12Map), Template13Map), Template14Map), Template15Map), Template18Map), Template20Map), Template24Map), Template27Map), Template29Map), Template30Map), Template31Map), Template33Map), Template37Map), Template38Map), Template44Map), Template45Map), Template47Map), Template48Map), Template49Map), Template55Map), Template57Map), Template58Map), Template59Map), Template60Map), Template61Map), Template62Map), Template63Map), Template65Map), Template67Map), Template71Map), Template79Map), Template80Map), Template81Map), Template83Map), Template84Map), Template85Map), Template86Map), Template87Map), Template88Map), Template89Map), Template90Map), Template91Map), Template92Map), Template93Map), Template94Map), Template95Map), Template96Map), Template97Map), Template99Map), Template100Map), Template101Map), Template102Map), Template103Map), Template104Map), Template106Map), Template107Map), Template108Map), Template109Map); // fetch(`https://ak01-promo-cdn.slidely.com/static/templates_2_0/js/index.bundle.js`).then(response => {
//     TEST = response;
// });
// const SCRIPT_URL = 'https://ak01-promo-cdn.slidely.com/static/templates_2_0/js/index.bundle.js';
// fetch(SCRIPT_URL)
//     .then(response => response.text()).then(text => {
//         debugger
//         TEST = text;
// });
// const scriptExport = import('val-loader!../../fetch-script2');


function createAnimation(animation) {
  // return fade animation
  if (animation.animationType === 'fade') {
    throw new Error('animationType fade - not supported any more');
  }

  if (animation.animationType === 'lottiewatermark') {
    return new _WatermarkImage.default(animation);
  } // if lottiephoto get animaton by start.transition as animationId


  if (animation.animationType === 'lottiephoto' && animationsMap[animation.start.transition]) {
    return animationsMap[animation.start.transition](animation);
  } // check animation id and return animaion


  if (animationsMap[animation.animationId]) {
    return animationsMap[animation.animationId](_objectSpread(_objectSpread({}, animation), {}, {
      data: (0, _lodash.default)(animation.data)
    }));
  } // no animation warn and return false


  window.console.warn('NO animation found for', animation.animationType, animation.animationId);
  return false;
}

function iconAnimation(id, options) {
  return new _IconAnimation.default(id, options);
}